/* NR · Motor de la página de membresía (product.member · sections/nr-member-*.liquid).
   Tres módulos independientes con null-guards: (1) galería (rail swipe + thumbs + contador
   + lightbox, patrón del PDP nr-pdp.js), (2) selector de DOS opciones (Camiseta × Talla:
   el PDP NR es mono-opción, la membresía necesita resolución cruzada de variante),
   (3) píldoras web|física de la sección "Cómo se usa". Sin dependencias. */
(function () {
  'use strict';

  /* prefers-reduced-motion: los scroll suaves del motor lo respetan (H15, patrón nr-pdp.js) */
  var NRM_SCROLL = (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'auto' : 'smooth';

  /* ============ 1 · Galería ============ */
  function initGaleria(root) {
    var gal = root.querySelector('[data-nrmb-galeria]');
    if (!gal) return;
    var rail = gal.querySelector('[data-nrmb-rail]');
    var slides = Array.prototype.slice.call(gal.querySelectorAll('[data-nrmb-slide]'));
    var count = gal.querySelector('[data-nrmb-count]');
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-nrmb-th]'));
    var lb = root.querySelector('[data-nrmb-lightbox]');
    var lbImg = lb ? lb.querySelector('[data-nrmb-lb-img]') : null;
    var lbClose = lb ? lb.querySelector('[data-nrmb-lb-close]') : null;
    var actual = 0;

    function marcar(i) {
      if (i === actual) return;
      actual = i;
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      thumbs.forEach(function (t, j) { t.classList.toggle('is-on', j === i); });
    }

    if (rail && slides.length > 1) {
      var raf = null;
      rail.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var x = rail.scrollLeft, mejor = 0, dist = Infinity;
          slides.forEach(function (s, i) {
            var d = Math.abs(s.offsetLeft - x);
            if (d < dist) { dist = d; mejor = i; }
          });
          marcar(mejor);
        });
      }, { passive: true });
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        var s = slides[i];
        if (s && rail) rail.scrollTo({ left: s.offsetLeft, behavior: NRM_SCROLL });
        marcar(i);
      });
    });

    /* Gestión de foco del diálogo (H7, patrón nr-pdp.js portado — gate web Jul 16):
       escapa del stacking context, foco a la ✕ al abrir, Tab atrapado, retorno al disparador */
    var lbTrigger = null;
    if (lb) {
      /* editor de temas: un re-render deja el lightbox anterior huérfano en body → limpiarlo */
      document.querySelectorAll('body > [data-nrmb-lightbox]').forEach(function (n) { n.remove(); });
      document.body.appendChild(lb);
    }
    function abrirLb(src) {
      if (!lb || !lbImg || !src) return;
      lbImg.src = src;
      lbTrigger = document.activeElement;
      lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      if (lbClose) lbClose.focus();
    }
    function cerrarLb() {
      if (!lb) return;
      lb.hidden = true;
      document.documentElement.style.overflow = '';
      if (lbTrigger && lbTrigger.focus) lbTrigger.focus();
      lbTrigger = null;
    }
    slides.forEach(function (s) {
      s.addEventListener('click', function () { abrirLb(s.getAttribute('data-full')); });
    });
    /* Guía de tallas: vive junto al selector, abre la última imagen (la guía en cm) */
    root.querySelectorAll('[data-nrmb-guia]').forEach(function (b) {
      b.addEventListener('click', function () { abrirLb(b.getAttribute('data-full')); });
    });
    if (lbClose) lbClose.addEventListener('click', cerrarLb);
    if (lb) {
      lb.addEventListener('click', function (e) { if (e.target === lb) cerrarLb(); });
      lb.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        /* a[href] estricto: [href] a secas matchea el <use href="#nr-x"> (no enfocable) — R-17 */
        var focusables = lb.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])');
        if (!focusables.length) return;
        var first = focusables[0], last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !lb.hidden) cerrarLb();
      });
    }
  }

  /* ============ 2 · Selector de dos opciones + ATC ============ */
  function initSelector(root) {
    var dataEl = root.querySelector('[data-nrmb-variants]');
    var form = root.querySelector('[data-nrmb-form]');
    if (!dataEl || !form) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var input = form.querySelector('[data-nrmb-variant-input]');
    var urg = root.querySelector('[data-nrmb-urgencia]');
    var urgTxt = urg ? urg.querySelector('[data-nrmb-urgencia-txt]') : null;
    var grupos = Array.prototype.slice.call(root.querySelectorAll('[data-nrmb-grupo]'));
    if (grupos.length === 0) return;
    var eleccion = {}; // índice de opción (0/1) → valor elegido

    function chipsDe(g) { return Array.prototype.slice.call(g.querySelectorAll('[data-nrmb-chip]')); }

    function variantePara(sel) {
      return variants.find(function (v) {
        return Object.keys(sel).every(function (k) { return v.opts[k] === sel[k]; });
      });
    }
    function hayDisponible(sel) {
      return variants.some(function (v) {
        return v.av && Object.keys(sel).every(function (k) { return v.opts[k] === sel[k]; });
      });
    }

    function pintar() {
      /* Disponibilidad cruzada: un chip se apaga si, fijando lo YA elegido en el otro
         grupo, no queda ninguna variante disponible con ese valor. Clases del PDP:
         is-agotada (tachado sobre superficie) e is-on (negro sólido). */
      grupos.forEach(function (g) {
        var idx = parseInt(g.getAttribute('data-nrmb-grupo'), 10);
        chipsDe(g).forEach(function (c) {
          var sel = {};
          Object.keys(eleccion).forEach(function (k) { if (parseInt(k, 10) !== idx) sel[k] = eleccion[k]; });
          sel[idx] = c.getAttribute('data-valor');
          var ok = hayDisponible(sel);
          c.classList.toggle('is-agotada', !ok);
          c.disabled = !ok;
          c.setAttribute('aria-pressed', eleccion[idx] === c.getAttribute('data-valor') ? 'true' : 'false');
          c.classList.toggle('is-on', eleccion[idx] === c.getAttribute('data-valor'));
        });
        var hint = g.querySelector('[data-nrmb-hint]');
        if (hint && eleccion[parseInt(g.getAttribute('data-nrmb-grupo'), 10)] !== undefined) hint.hidden = true;
      });

      var completa = grupos.every(function (g) {
        return eleccion[parseInt(g.getAttribute('data-nrmb-grupo'), 10)] !== undefined;
      });
      var v = completa ? variantePara(eleccion) : null;
      input.value = v && v.av ? v.id : '';

      /* Urgencia honesta (string canónico del PDP): rastreado y ≤3 unidades */
      if (urg && urgTxt) {
        if (v && v.av && v.track && v.qty > 0 && v.qty <= 3) {
          /* des-ocultar ANTES de escribir: una región live oculta no anuncia su 1ª aparición */
          urg.hidden = false;
          urgTxt.textContent = v.qty === 1 ? '¡Vuelan! Solo queda 1 en tu talla' : '¡Vuelan! Solo quedan ' + v.qty + ' en tu talla';
        } else {
          urg.hidden = true;
        }
      }
    }

    grupos.forEach(function (g) {
      var idx = parseInt(g.getAttribute('data-nrmb-grupo'), 10);
      chipsDe(g).forEach(function (c) {
        c.addEventListener('click', function () {
          if (c.disabled) return;
          if (eleccion[idx] === c.getAttribute('data-valor')) delete eleccion[idx];
          else eleccion[idx] = c.getAttribute('data-valor');
          pintar();
        });
      });
    });

    /* Guarda del submit: nunca hay valor preseleccionado (regla Jul 4).
       Gesto del PDP: hint rojo + sacudida de la fila de chips. */
    function señalarFaltante() {
      var faltante = null;
      grupos.forEach(function (g) {
        var idx = parseInt(g.getAttribute('data-nrmb-grupo'), 10);
        if (eleccion[idx] === undefined && !faltante) faltante = g;
      });
      if (!faltante) return;
      var hint = faltante.querySelector('[data-nrmb-hint]');
      if (hint) hint.hidden = false;
      var fila = faltante.querySelector('.nrp__tallas');
      if (fila) {
        fila.classList.remove('is-shake');
        void fila.offsetWidth;
        fila.classList.add('is-shake');
      }
      faltante.scrollIntoView({ behavior: NRM_SCROLL, block: 'center' });
    }
    form.addEventListener('submit', function (e) {
      if (!input.value) {
        e.preventDefault();
        señalarFaltante();
        return;
      }
      /* Flip carrito (re-run code-review Jul 16): agregar por AJAX + abrir el drawer NR —
         patrón de TODO el sitio («muere el redirect a /cart», Jul 6), portado de nr-pdp.js.
         Sin motor o con excepción de red → submit nativo intacto. */
      if (!window.NRCart || !window.fetch) return;
      e.preventDefault();
      var atcBtn = form.querySelector('[data-nrmb-atc]');
      var disparador = (document.activeElement && document.activeElement !== document.body) ? document.activeElement : atcBtn;
      var atcHtml = atcBtn ? atcBtn.innerHTML : '';
      if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Agregando…'; }
      var restaurar = function () { if (atcBtn) { atcBtn.disabled = false; atcBtn.innerHTML = atcHtml; } };
      var fd = new FormData(form);
      fd.append('sections', 'nr-cart-drawer');
      fetch('/cart/add.js', { method: 'POST', body: fd })
        .then(function (r) {
          if (!r.ok) {
            /* 422 (agotado/tope): la voz del server en el hint rojo MÁS CERCANO al botón (aria-live) */
            return r.json().catch(function () { return {}; }).then(function (j) {
              restaurar();
              var hints = root.querySelectorAll('[data-nrmb-hint]');
              var hint = hints[hints.length - 1];
              if (hint) { hint.textContent = j.description || 'No se pudo agregar. Intenta de nuevo.'; hint.hidden = false; }
            });
          }
          /* add EXITOSO: pase lo que pase de aquí en adelante, NUNCA re-postear (doble unidad) —
             si el parse/swap falla, navegar a /cart ya con el ítem dentro */
          return r.json().then(function (j) {
            restaurar();
            try {
              if (j.sections && j.sections['nr-cart-drawer']) window.NRCart.swap(j.sections['nr-cart-drawer']);
              window.NRCart.open(disparador);
            } catch (err) { window.location.href = '/cart'; }
          }).catch(function () { restaurar(); window.location.href = '/cart'; });
        })
        .catch(function () { restaurar(); form.submit(); }); /* solo red caída ANTES del add */
    });

    /* ATC sticky móvil (patrón del PDP): aparece cuando el ATC principal sale de vista */
    var sticky = root.querySelector('[data-nrmb-sticky]');
    var stickyBtn = root.querySelector('[data-nrmb-sticky-btn]');
    if (sticky && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (en) {
          sticky.hidden = en.isIntersecting || en.boundingClientRect.top > 0;
        });
      }, { threshold: 0 });
      io.observe(form);
    }
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (input.value) {
          /* guard Safari/iOS < 16 (patrón nr-pdp.js): sin requestSubmit → submit nativo */
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.submit();
          return;
        }
        señalarFaltante();
      });
    }

    pintar();
  }

  /* ============ 3 · Píldoras web|física (Cómo se usa) ============ */
  /* Patrón WAI-ARIA Tabs completo (gate web Jul 16, calco de nr-rostros.js):
     ids + aria-controls/labelledby cableados aquí, roving tabindex, flechas ←→, Home/End */
  function initUso() {
    document.querySelectorAll('[data-nrmu-tabs]').forEach(function (zona, z) {
      if (zona.dataset.nrmuBound) return;
      zona.dataset.nrmuBound = '1';
      var tabs = Array.prototype.slice.call(zona.querySelectorAll('[data-nrmu-tab]'));
      var paneles = Array.prototype.slice.call(zona.querySelectorAll('[data-nrmu-panel]'));

      tabs.forEach(function (t) {
        var id = t.getAttribute('data-nrmu-tab');
        t.id = 'nrmu-tab-' + z + '-' + id;
        t.setAttribute('aria-controls', 'nrmu-panel-' + z + '-' + id);
      });
      paneles.forEach(function (p) {
        var id = p.getAttribute('data-nrmu-panel');
        p.id = 'nrmu-panel-' + z + '-' + id;
        p.setAttribute('aria-labelledby', 'nrmu-tab-' + z + '-' + id);
      });

      function activar(id, conFoco) {
        tabs.forEach(function (o) {
          var on = o.getAttribute('data-nrmu-tab') === id;
          o.classList.toggle('is-on', on);
          o.setAttribute('aria-selected', on ? 'true' : 'false');
          o.tabIndex = on ? 0 : -1;
          if (on && conFoco) o.focus();
        });
        paneles.forEach(function (p) { p.hidden = p.getAttribute('data-nrmu-panel') !== id; });
      }
      /* estado inicial: roving tabindex sobre el is-on sembrado */
      var inicial = tabs.filter(function (t) { return t.classList.contains('is-on'); })[0] || tabs[0];
      if (inicial) activar(inicial.getAttribute('data-nrmu-tab'), false);

      tabs.forEach(function (t, pos) {
        t.addEventListener('click', function () { activar(t.getAttribute('data-nrmu-tab'), false); });
        t.addEventListener('keydown', function (e) {
          var next = null;
          switch (e.key) {
            case 'ArrowRight': case 'ArrowDown': next = (pos + 1) % tabs.length; break;
            case 'ArrowLeft': case 'ArrowUp': next = (pos - 1 + tabs.length) % tabs.length; break;
            case 'Home': next = 0; break;
            case 'End': next = tabs.length - 1; break;
            default: return;
          }
          e.preventDefault();
          activar(tabs[next].getAttribute('data-nrmu-tab'), true);
        });
      });
    });
  }

  function init() {
    var root = document.querySelector('[data-nr-member]');
    if (root && !root.dataset.nrMemberBound) {
      root.dataset.nrMemberBound = '1';
      initGaleria(root);
      initSelector(root);
    }
    initUso();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
